import { IRangeValues, IArboardResize } from '@state/dsconfig/types';
import Konva from 'konva';
import { IResizeValues } from '@routes/private/Editor/Editor/CommandsBars/MainCommandBar/CommandsOptions/ResizeArtboardCommandOption/types'
import { IElement } from '@routes/private/Editor/types';
import { moveStageXY } from '@utils/editor';
import { IEntityInformation} from '@routes/private/Editor/types';
import { Preview } from '@state/designs/types';

export const artboardResizeLimits = (oldBox: any, newBox: any, cropTrRef: any, limits: IRangeValues) => { 
    const zoomX = cropTrRef.current.getLayer()?.getStage().scaleX()??1;
    const limitsMin = (limits.min * zoomX); 
    if (newBox.width<limitsMin || newBox.x<0) {
        newBox.width = oldBox.width;
        newBox.x = oldBox.x;
    }
    if (newBox.height<limitsMin || newBox.y<0) {
        newBox.height = oldBox.height;
        newBox.y = oldBox.y;
    }
    return newBox;
}

export const getArboardByID = (layer: Konva.Layer | null, artboardId: string, artboardResize?: boolean) => {
    let artboardFound : any = undefined;
    layer?.getChildren().forEach((groupElementNode: any) => {
        if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id === artboardId)
            artboardFound = groupElementNode;
        
        if (artboardResize && groupElementNode.attrs.id === artboardId)
            artboardFound = groupElementNode;
    });
    return artboardFound;
}

export const getNodestOutside = (elements: any[], nodestOutsideList: IResizeValues[], artboadrBox: any) => {
    elements?.forEach((childrenNode: any) => {
        const childrenNodeBox = childrenNode.getClientRect();
        if (childrenNodeBox && !Konva.Util.haveIntersection(artboadrBox, childrenNodeBox) && childrenNode.attrs.id  &&
        !childrenNode.attrs.id.includes("textPart")) {
            nodestOutsideList.push({id: childrenNode.attrs.id, 
                    x: childrenNode.attrs.x, 
                    y: childrenNode.attrs.y , 
                    width: childrenNode.attrs.width, 
                    height: childrenNode.attrs.height,
                    command: 'removeElement'});
        } else if (childrenNode.children) nodestOutsideList = getNodestOutside(childrenNode.children, nodestOutsideList, artboadrBox)
    });
    return nodestOutsideList;
}

export const getElementsToUpdate = (layer: Konva.Layer | null, newValues: IResizeValues, oldValues:IResizeValues, activeAnchor: string, nearbyArtboards: any, artboardResize?:IArboardResize) => {
    const artboardResizeValues = artboardResize??{min: 10, max: 4000, minSpaceX: 50, minSpaceY: 50};
    newValues = getArtboardPosition(layer, newValues, oldValues, activeAnchor, nearbyArtboards, artboardResizeValues);
    let elementsUpdate: IResizeValues[] = [];
    let groupElementNode: any = getArboardByID(layer, newValues.id);
    if (groupElementNode) {
        const artboardBox = groupElementNode.children[0].getClientRect();
        elementsUpdate = getNodestOutside(groupElementNode.children, [],artboardBox)

        let artboardsToMove: IResizeValues[] = [];
        // move artboads in Y after in X.
        if (newValues.moveElementsY) artboardsToMove = moveElementsXY(layer, groupElementNode, newValues, oldValues, false, true);
        if (newValues.moveElementsX) artboardsToMove = moveElementsXIntersection(layer, newValues, oldValues, newValues.id, artboardsToMove, artboardResizeValues, true);

        elementsUpdate = [...elementsUpdate , ...artboardsToMove, newValues];
        
    }
    return elementsUpdate
}

export const getArtboardsMove = (layer: Konva.Layer | null, artboardMoved: any, newValues: IResizeValues, oldValues: IResizeValues) => {
    let artboardsToMove: IResizeValues[] = [];
    const artboardMovedBox = artboardMoved.children[0].getClientRect();

    let moveRight: number = newValues.width - oldValues.width;
    let moveBottom: number = newValues.height - oldValues.height;

    layer?.getChildren().forEach((groupElementNode: any) => {
        if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id !== artboardMoved.attrs.id){
            const artboadBox = groupElementNode.children[0].getClientRect();
            let resizeValues : IResizeValues={
                id: groupElementNode.attrs.id,
                x: groupElementNode.children[0].attrs.x,
                y: groupElementNode.children[0].attrs.y,
                width: groupElementNode.children[0].attrs.width,
                height: groupElementNode.children[0].attrs.height,
                rotation: undefined,
                command: 'resizeArtboard'
            }
            
            let add = false;
            
            let oldX = artboadBox.x;
            artboadBox.x = artboardMovedBox.x;
            if (Konva.Util.haveIntersection(artboadBox, artboardMovedBox) && oldX>artboardMovedBox.x) { //move right
                resizeValues.x =groupElementNode.children[0].attrs.x + moveRight;
                resizeValues.moveChildrenX = moveRight;
                add = true;
            }

            let oldY = artboadBox.y;
            artboadBox.y = artboardMovedBox.y;
            artboadBox.x = oldX;
            if (Konva.Util.haveIntersection(artboadBox, artboardMovedBox) && !add && oldY>artboardMovedBox.y) { //move right
                resizeValues.y =groupElementNode.children[0].attrs.y + moveBottom;
                resizeValues.moveChildrenY = moveBottom;
                add = true;
            }

            if (add) artboardsToMove.push(resizeValues);
            
        }
    });
    return artboardsToMove;
}

export const getArtboardPosition = (layer: Konva.Layer | null, newValues: IResizeValues, oldValues: IResizeValues, activeAnchor: string, nearbyArtboards: any, artboardResize:IArboardResize ) => {
    let artboardMoved: any = getArboardByID(layer, newValues.id);
    const artboardMovedBox = artboardMoved.children[0].attrs
    const minX = artboardResize?.minSpaceX??50;
    const minY = artboardResize?.minSpaceY??50;

    if ((activeAnchor==="top-left" || activeAnchor==="bottom-left") && nearbyArtboards.left) {
        let artboardLeft: any = getArboardByID(layer, nearbyArtboards.left);
        const artboadBox = artboardLeft.children[0].attrs
        let limitX = artboadBox.x + artboadBox.width + minX;
        let spaceOver = limitX - artboardMovedBox.x;
        newValues.x =  newValues.x + spaceOver;
        newValues.moveChildrenX = (newValues.x - oldValues.x) + (newValues.width - oldValues.width);
        newValues.moveElementsX = (newValues.x - oldValues.x) + (newValues.width - oldValues.width);
    }

    if ((activeAnchor==="top-left" || "top-right") && nearbyArtboards.top) {
        let artboardTop: any = getArboardByID(layer, nearbyArtboards.top);
        const artboadBox = artboardTop.children[0].attrs
        let limitY = artboadBox.y + artboadBox.height + minY;
        let spaceOver = limitY - artboardMovedBox.y;
        newValues.y =  newValues.y + spaceOver;
        newValues.moveChildrenY = (newValues.y - oldValues.y) + (newValues.height - oldValues.height);
        newValues.moveElementsY = (newValues.y - oldValues.y) + (newValues.height - oldValues.height);
    }

    if ((activeAnchor==="bottom-left" || activeAnchor==="bottom-right") && nearbyArtboards.bottom) {
        let artboardBottom: any = getArboardByID(layer, nearbyArtboards.bottom);
        const artboadBox = artboardBottom.children[0].attrs
        let limitY = artboardMovedBox.y + artboardMovedBox.height + minY;
        let spaceOver = limitY - artboadBox.y;
        newValues.moveElementsY = spaceOver>0? spaceOver : undefined;
    }

    if ((activeAnchor==="top-right" || activeAnchor==="bottom-right") && nearbyArtboards.right) {
        let artboardRight: any = getArboardByID(layer, nearbyArtboards.right);
        const artboadBox = artboardRight.children[0].attrs
        let limitX = artboardMovedBox.x + artboardMovedBox.width + minX;
        let spaceOver = limitX - artboadBox.x;
        newValues.moveElementsX = spaceOver;
    }

    const artboadBox = artboardMoved.children[0].attrs;
    if (artboadBox.x<0 && activeAnchor!=="top-right" && activeAnchor!== "bottom-right" && !nearbyArtboards.left) {
        newValues.moveChildrenX = (newValues.x*-1);
        newValues.moveElementsX = (newValues.x*-1);
        newValues.x = 0;
    }
    if (artboadBox.y<0 && activeAnchor!=="bottom-left" && activeAnchor!=="bottom-right" && !nearbyArtboards.top) {
        newValues.moveChildrenY = (newValues.y*-1);
        newValues.moveElementsY = (newValues.y*-1);
        newValues.y = 0;
    }

    return newValues;
}

export const updateArtboardPosition = ( resizeValues: IResizeValues, rectInsideRef: any, groupRef: any, labelResize?: any, rectResizeRef?: any, textResize?: any, textRef?: any, groupResizeRef?: any) => {
    //setAttributes(props.element.attributes);
    const nodeRectInside = rectInsideRef.current??rectInsideRef;
    nodeRectInside.x(resizeValues.x);
    nodeRectInside.y(resizeValues.y);

    // Update group container
    const nodeGroup = groupRef.current??groupRef;
    //x,y +1
    nodeGroup.clipX(resizeValues.x);
    nodeGroup.clipY(resizeValues.y);
    //width/height -2
    nodeGroup.clipWidth(resizeValues.width);
    nodeGroup.clipHeight(resizeValues.height);
    nodeGroup.setPosition({x:0, y: 0});

    if (rectResizeRef?.current) {
        rectResizeRef?.current.x(resizeValues.x);
        rectResizeRef?.current.y(resizeValues.y);
    }

    if (labelResize?.current) {
        //Update tooltip resize text.
      const nodeLabelInfo = labelResize.current;
      nodeLabelInfo.visible(true);
      nodeLabelInfo.x(resizeValues.x + ((resizeValues.width/2)-(nodeLabelInfo.width()/2)));
      nodeLabelInfo.y(resizeValues.y + resizeValues.height+15);
      const nodeTextInfo = textResize.current;
      nodeTextInfo.text(`${Math.round(resizeValues.width)}x${Math.round(resizeValues.height)}`);
    }

    if (textRef?.current) {
        const nodeText = textRef.current;
        nodeText.x(resizeValues.x);
        nodeText.y(resizeValues.y-20);
    }

    if (groupResizeRef) {
        const nodeResizegroup = groupResizeRef.current??groupResizeRef;
        nodeResizegroup.setPosition({x:0, y: 0});
    }
}

export const getNearbyArtboards = (nearbyArtboards: any, resizingArtboard: React.MutableRefObject<Konva.Rect>, layer:any, oldValues: IResizeValues, resizingArtboardId: string, activeAnchor: string, artboardResizeValues: IArboardResize, smallerX: boolean, smallerY: boolean) => {
    const resizingArtboardBox = resizingArtboard.current.getClientRect();
    let artboardResize: IArboardResize = {...artboardResizeValues};
    let scale = resizingArtboard.current.getAbsoluteScale();
    if (scale) {
        artboardResize.minSpaceX = artboardResize.minSpaceX * scale.x;
        artboardResize.minSpaceY = artboardResize.minSpaceY * scale.y;
    }

    resizingArtboardBox.width = resizingArtboardBox.width+ artboardResize.minSpaceX;
    resizingArtboardBox.height = resizingArtboardBox.height+artboardResize.minSpaceY;
    if (activeAnchor==="top-left") {
        resizingArtboardBox.x = resizingArtboardBox.x-artboardResize.minSpaceX;
        resizingArtboardBox.y = resizingArtboardBox.y-artboardResize.minSpaceY;
    }
    if (activeAnchor==="top-right") resizingArtboardBox.y = resizingArtboardBox.y-artboardResize.minSpaceY;
    if (activeAnchor==="bottom-left") resizingArtboardBox.x = resizingArtboardBox.x-artboardResize.minSpaceX;

    let intersection: boolean=false;
    layer.getChildren().forEach((groupElementNode: any) => {
        if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id !== resizingArtboardId) {
            const otherArtboard = groupElementNode.children[0].getClientRect();
            if (otherArtboard && Konva.Util.haveIntersection(resizingArtboardBox, otherArtboard)) {
                const overLeft = oldValues.x > (groupElementNode.children[0].attrs.x + groupElementNode.children[0].attrs.width);
                const overTop = oldValues.y > (groupElementNode.children[0].attrs.y + groupElementNode.children[0].attrs.height);
                const overRight = (oldValues.x+oldValues.width) < groupElementNode.children[0].attrs.x;
                const overBottom = (oldValues.y+oldValues.height) < groupElementNode.children[0].attrs.y;
                
                if (overLeft && !nearbyArtboards.left) 
                    nearbyArtboards.left = groupElementNode.attrs.id;
                if (overTop && !nearbyArtboards.top) 
                    nearbyArtboards.top = groupElementNode.attrs.id;
                if (overRight && !nearbyArtboards.right) 
                    nearbyArtboards.right = groupElementNode.attrs.id;
                if (overBottom && !nearbyArtboards.bottom) 
                    nearbyArtboards.bottom = groupElementNode.attrs.id;

                intersection = true;
            }
        }
    });

    if ((activeAnchor==="top-left" || activeAnchor==="bottom-left") && smallerX) {
        nearbyArtboards.left =  undefined;
        nearbyArtboards.right =  undefined;
    }
    if ((activeAnchor==="bottom-left" || activeAnchor==="bottom-right") && smallerY) {
        nearbyArtboards.bottom =  undefined;
        nearbyArtboards.top =  undefined;
    }

    if ((activeAnchor==="top-left" || activeAnchor==="top-right") && smallerY) {
        nearbyArtboards.top =  undefined;
    }

    if (!intersection) nearbyArtboards = {left: undefined, right: undefined, top: undefined, bottom: undefined};
    return nearbyArtboards;
}

export const moveElementsXY = (layer: Konva.Layer | null, artboardMoved: any, newValues: IResizeValues, oldValues: IResizeValues, moveX: boolean, moveY: boolean, moveAll?: boolean) => {
    //Update artboard resize position
    updateArtboardPosition(newValues, artboardMoved.children[0], artboardMoved);
    let moveElementX: number = moveX ? newValues.moveElementsX??0 : 0;
    let moveElementY: number = moveY ? newValues.moveElementsY??0 : 0;
    let artboardsToMove: IResizeValues[] = [];
    layer?.getChildren().forEach((groupElementNode: any) => {
        if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id !== artboardMoved.attrs.id){
            const wasBottom = (oldValues.y+oldValues.height) < groupElementNode.children[0].attrs.y;

            let resizeValues : IResizeValues={
                id: groupElementNode.attrs.id,
                x: groupElementNode.children[0].attrs.x+moveElementX,
                y: groupElementNode.children[0].attrs.y+moveElementY,
                width: groupElementNode.children[0].attrs.width,
                height: groupElementNode.children[0].attrs.height,
                rotation: undefined,
                command: 'resizeArtboard',
                moveChildrenY: moveElementY,
                moveChildrenX: moveElementX
            }
            if (wasBottom || moveAll) {
                updateArtboardPosition(resizeValues, groupElementNode.children[0], groupElementNode);
                artboardsToMove.push(resizeValues)
            }
        }
    });
    return artboardsToMove;
}

export const moveElementsXIntersection = (layer: Konva.Layer | null, newValues: IResizeValues, oldValues: IResizeValues, idInitialArtboard: string, artboardsToMove: IResizeValues[], artboardResizeValues:IArboardResize, init: boolean) => {
    let moveRight: number = newValues.moveElementsX??0;

    let initialNode: any = getArboardByID(layer, idInitialArtboard);
    if (init) updateArtboardPosition(newValues, initialNode.children[0], initialNode);

    let artboardResize: IArboardResize = {...artboardResizeValues};
    let scale = initialNode.children[0].getAbsoluteScale();
    if (scale) {
        artboardResize.minSpaceX = artboardResize.minSpaceX * scale.x;
        artboardResize.minSpaceY = artboardResize.minSpaceY * scale.y;
    }
    const artboardBox = initialNode.children[0].getClientRect();
    artboardBox.width = artboardBox.width + artboardResize.minSpaceX;

    layer?.getChildren().forEach((groupElementNode: any) => {
        if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id !== idInitialArtboard){
            const otherArtboard = groupElementNode.children[0].getClientRect();
            
            if (otherArtboard && Konva.Util.haveIntersection(artboardBox, otherArtboard)) {
                const wasRight = (oldValues.x+oldValues.width) < groupElementNode.children[0].attrs.x;
                
                let searchValues: number = artboardsToMove.findIndex((values:IResizeValues) => values.id===groupElementNode.attrs.id);
                let resizeValues : IResizeValues= artboardsToMove[searchValues]??{
                    id: groupElementNode.attrs.id,
                    x: groupElementNode.children[0].attrs.x,
                    y: groupElementNode.children[0].attrs.y,
                    width: groupElementNode.children[0].attrs.width,
                    height: groupElementNode.children[0].attrs.height,
                    rotation: undefined,
                    command: 'resizeArtboard'
                }

                resizeValues.x = groupElementNode.children[0].attrs.x+moveRight;
                resizeValues.moveChildrenX = moveRight;

                if (wasRight) {
                    if (artboardsToMove[searchValues]) artboardsToMove[searchValues] = resizeValues;
                    else artboardsToMove.push(resizeValues);

                    updateArtboardPosition(resizeValues, groupElementNode.children[0], groupElementNode);
                    moveElementsXIntersection(layer, newValues, oldValues, groupElementNode.attrs.id, artboardsToMove, artboardResize, false);
                }
            }
        }
    });
    return artboardsToMove;
}

export const showTransfomerOutsideArtboard = (layer: Konva.Layer | null, groupResizeRef: React.MutableRefObject<Konva.Group>, zIndexInitial?: number, groupRef?: React.MutableRefObject<Konva.Group> ) => {
    if (layer) {
        //DOS-79: max zIndex = Length of layer's children minus 1 (length = 10 then max ZIndex = 9)
        let layerChildrenLen=layer.children?.length??1;
        let zIndex = zIndexInitial??(layerChildrenLen-1);
        //let zIndex = zIndexInitial??layer.children?.length??0;
        if (groupResizeRef.current) groupResizeRef.current.zIndex(zIndex);
        if (groupRef?.current) groupRef.current.zIndex(zIndex+1);
    }
}

export const artboardNewName = (str: string, newWidth: number, newHeight:number) => {
    let divide = str.split("x");
    if (divide.length>1) {
        var number1 = divide[0].trim().replace(/\D/g, "");
        var number2 = divide[1].trim().replace(/\D/g, "");
        if (number1.length>0 && number2.length>0) {
            str = str.replace(number1, `${Math.round(newWidth)}`)
            str = str.replace(number2, `${Math.round(newHeight)}`)
        }
    }
    return str;
}

export const reverseScaleTooltip = (nodeRef: any, positionX: number, positionY: number) => {
    let node = nodeRef.current;
    const absScale = node.getAbsoluteScale();
    let scaleY = node.scaleY() / absScale.y;
    let scaleX = node.scaleX() / absScale.x;
    node.scaleX(scaleX);
    node.scaleX(scaleX);
    node.y(positionY - (node.height()+15)*scaleY);
    node.x(positionX - (node.width()*scaleX));
}

export const getOldValuesArtboard = (element: IElement) => {
    let oldValues : IResizeValues={
        id: element.id,
        x: element.attributes.x,
        y: element.attributes.y,
        width: element.attributes.width,
        height: element.attributes.height,
        rotation: undefined
    }
    return oldValues;
}

export const updateArtboard = (layer: Konva.Layer | null, stageRef: any, newValues: IResizeValues, oldValues: IResizeValues, artboardResize: IArboardResize) => {
    let arboardUpdate: any = getArboardByID(layer, newValues.id);
    let arboardResize: any = getArboardByID(layer, `artboard-resize-${newValues.id}`, true);

    let moveArtboard: boolean =  true;
    if (arboardUpdate) {
        const artboardBox = arboardResize.children[0].getClientRect();
        const artboardBoxRect = arboardResize.children[1].getClientRect();

        if(artboardBox && artboardBoxRect) {
            layer?.getChildren().forEach((groupElementNode: any) => {
                if ( groupElementNode.attrs.type === "artboard" &&  groupElementNode.attrs.id !== newValues.id){
                    const otherArtboard = groupElementNode.children[0].getClientRect();
                    if ((otherArtboard && Konva.Util.haveIntersection(artboardBox, otherArtboard)) ||
                    (otherArtboard && Konva.Util.haveIntersection(artboardBoxRect, otherArtboard))) 
                        moveArtboard = false;
                }
            });
        }
    }
    let artboardsToMove: IResizeValues[] = []
    if (moveArtboard) {
        if (newValues.x<0) {
            newValues.moveChildrenX = oldValues.x*-1;
            newValues.moveElementsX = newValues.x*-1;
            newValues.x = 0;
        } else  newValues.moveChildrenX = newValues.x-oldValues.x;
        
        if (newValues.y<0) {
            newValues.moveChildrenY = oldValues.y*-1+20;
            newValues.moveElementsY = newValues.y*-1+20;
            newValues.y = 20;
        } else  newValues.moveChildrenY = newValues.y-oldValues.y;

        if (newValues.moveElementsX || newValues.moveElementsY) artboardsToMove = moveElementsXY(layer, arboardUpdate, newValues, oldValues, true, true, true);
        artboardsToMove = [newValues, ...artboardsToMove];
        if (newValues.moveElementsX || newValues.moveElementsY)
            moveStageXY(stageRef, newValues.moveElementsX??0, newValues.moveElementsY??0)
    } else {
        updateArtboardPosition(oldValues, 
                        arboardUpdate.children[0], 
                        arboardUpdate, 
                        undefined, 
                        undefined, 
                        undefined, 
                        undefined, 
                        arboardResize
        );
    }
    return moveArtboard ? artboardsToMove : undefined;
}

export const getArtboardPreview = (previews: Preview[], artboardName: string) => {
    return previews.find((preview: Preview) => preview.name===artboardName);
}